import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/61450645926?text=Hey%20Velocity%2C%20I%27m%20interested%20in%20getting%20some%20work%20done"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-btn"
      className="fixed bottom-6 right-6 z-30 flex items-center gap-2 bg-[#25D366] text-white pl-4 pr-5 py-3 hover:bg-[#20BD5A] transition-colors shadow-lg shadow-[#25D366]/20 group no-underline"
      style={{ borderRadius: "50px" }}
    >
      <MessageCircle size={20} className="fill-white" />
      <span className="font-heading text-sm tracking-[0.1em] uppercase hidden sm:inline">WhatsApp Us</span>
    </a>
  );
};
